import { calcLineHeight } from '../utils'
import { DNA } from '../visual-language'
import { LevelProps } from './tokens'

export const headingStyles = ({
  level = 'large',
}: HeadingStylesProps = {}) => ({
  margin: 0,
  ...levelStyles[level],
})

const levelStyles = {
  xlarge: {
    fontSize: DNA.tokens.dimension.font[700],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[700],
      lineHeight: 1.3,
    }),
  },
  large: {
    fontSize: DNA.tokens.dimension.font[600],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[600],
      lineHeight: 1.3,
    }),
  },
  medium: {
    fontSize: DNA.tokens.dimension.font[500],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[500],
      lineHeight: 1.3,
    }),
  },
  small: {
    fontSize: DNA.tokens.dimension.font[400],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[400],
      lineHeight: 1.3,
    }),
  },
  xsmall: {
    fontSize: DNA.tokens.dimension.font[300],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[300],
      lineHeight: 1.3,
    }),
  },
}

export interface HeadingStylesProps extends Partial<LevelProps> {}
